import React, { useState } from 'react'
import { Popup } from '../../../shared/modal/index'
import {FavorGroupPanel} from './favor_group_panel'
import newzxg from '../../../../modules/newzxg/web'
import { store } from '../../../../store/favor/store'
import { Observer } from 'mobx-react-lite'
import { toJS } from 'mobx'
import { NoticeTipDialog } from '../../../shared/notice'
import { getDelayParam } from '../../../../modules/quote/web'

interface FavorGroup{
  gid: string, 
  gname: string, 
  fromclient: string, 
  ver: number, 
  checkClass: string
}

export function FavorGroupList() {
  const [editPanelVisible, setEditPanelVisible] = useState(false)
  const [popupVisible, setPopupVisible] = useState(false)
  const [currentFavor, setCurrentFavor] = useState({ id: '', name: '' })
  const [noticeTip, setNoticeTip] = useState({ noticeVisible: false, noticeContent: '' })

  const EditFavorGroup = (id: string, name: string) => {
    setEditPanelVisible(true)
    setCurrentFavor({ id, name })
  }

  const DelFavorGroup = (id: string, name: string) => {
    setPopupVisible(true)
    setCurrentFavor({ id, name })
  }

  // 确认删除自选分组
  const onConfirm = async () => {
    if (!currentFavor.id) return
    const result = await newzxg.deleteGroup(currentFavor.id)
    if (result && result.re) {
      setNoticeTip({
        noticeVisible: true,
        noticeContent: '组合删除成功',
      })
      //移除对象分组集合
      let data = await store.getGroupList()
      store.setGroupList(data)
    } else {
      if (currentFavor.name == '自选股') {
        setNoticeTip({
          noticeVisible: true,
          noticeContent: '默认组合不允许删除或修改',
        })
      } else {
        setNoticeTip({
          noticeVisible: true,
          noticeContent: '组合删除失败',
        })
      }
    }
    setPopupVisible(false)
  }

  // 自选分组选中事件
  const checkGroupIcon = async (item: FavorGroup, index: number) => {
    store.setCheckClass(index, 'icon-check checked')

    store.GroupList.result.map((v: FavorGroup, i: number) => {
      if (v.gid != item.gid) {
        store.setCheckClass(i, 'icon-check')
      }
    })
    store.setTitle(item.gname)

    let tempFavors = store.GroupList?.result?.map((v: FavorGroup) => v.gid)
    let getindex = tempFavors.indexOf(item.gid)
    let tempcode = tempFavors?.[0]
    tempFavors[0] = item.gid
    tempFavors[getindex] = tempcode
    store.setFavors(tempFavors)
    store.setNewFavors(tempFavors)

    if (store.newFavors.length) {
      const data: any = store.GroupList?.result?.filter((item: FavorGroup) => {
        return item.gid == store.newFavors?.[0]
      })
      store.setCurrentFavor(data[0])
    }

    const delayParam = await getDelayParam()
    if (delayParam) {
      // 防止stockCodes改变后二次请求
      store.setDelayFlag(false)
    }
    let GroupStocks = await store.getGroupStockByID()
    store.setGroupStocks(GroupStocks)
    GroupStocks && store.setStockCodes(GroupStocks.result.map((v: any) => v.code))

    if (delayParam) {
      store.getDelayQuote(JSON.parse(delayParam), store.stockCodes)
      store.setDelayFlag(true)
    }
    
    // 重置分页参数
    store.setParam({cmd: '', pindex: 1, psize: 30, sr: 1, st: ''})
    store.setStockScroll("stock-scroll")
    store.setFavorGroupVisible(false)
  }

  return (
    <Observer>
      {() => (
        <>
          <div>
            {store.GroupList?.result?.length ? (
              <dl>
                {store.GroupList?.result?.map((item:FavorGroup, index: number) => {
                  return (
                    <dd key={item.gid} data-favor={item.gid} data-title={item.gname} className="favorgroup-item">
                      <span>
                        <a href="#" className={store.manageBtn == '管理' ? 'disappear' : 'icon-del'} onClick={(e) => {e.preventDefault();DelFavorGroup(item.gid, item.gname)}}></a>
                        <label className="groupItem-title">{item.gname}</label>
                      </span>
                      <a href="#" className={store.manageBtn == '管理' ? (item?.gid == toJS(store?.favors)?.[0] ? `icon-check checked` : `${item.checkClass}`) : 'disappear'} onClick={(e) => {e.preventDefault();checkGroupIcon(item, index)}} data-favor={item.gid}></a>
                      <a href="#"  className={store.manageBtn == '管理' ? 'disappear' : 'icon-edit'} onClick={(e) =>{e.preventDefault();EditFavorGroup(item.gid, item.gname)} }></a>
                    </dd>
                  )
                })}
              </dl>
            ) : (
              <div className="ctr-cls">暂无自选股列表</div>
            )}
          </div>
          {editPanelVisible && <FavorGroupPanel type="edit" currentFavor={currentFavor} onClose={()=>setEditPanelVisible(false)}/>}

          {popupVisible && (
            <Popup
              title={`确认删除“${currentFavor.name}”？`}
              class={'center'}
              onCancel={() => {
                setPopupVisible(false)
              }}
              onConfirm={() => onConfirm()}
            />
          )}
          {noticeTip.noticeVisible && <NoticeTipDialog content={noticeTip.noticeContent} noIcon={true} onClose={() => setNoticeTip({ noticeVisible: false, noticeContent: '' })} />}
        </>
      )}
    </Observer>
  )
}
